document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.fu-countdown').forEach((el) => {
		const target = new Date(el.dataset.target).getTime();
		if (isNaN(target)) return;

		function update() {
			const diff = Math.max(0, target - Date.now());
			set(el, 'days', Math.floor(diff / 86400000));
			set(el, 'hours', Math.floor((diff % 86400000) / 3600000));
			set(el, 'minutes', Math.floor((diff % 3600000) / 60000));
			set(el, 'seconds', Math.floor((diff % 60000) / 1000));
		}

		function set(root, unit, value) {
			const unitEl = root.querySelector('[data-unit="' + unit + '"]');
			if (!unitEl) return;
			const container = unitEl.querySelector('.fu-countdown__digits');
			const digitEls = container.querySelectorAll('.fu-countdown__digit');
			const str = String(value).padStart(2, '0');

			if (digitEls.length !== str.length) {
				container.innerHTML = '';
				for (var i = 0; i < str.length; i++) {
					var d = document.createElement('span');
					d.className = 'fu-countdown__digit';
					var s = document.createElement('span');
					s.textContent = str[i];
					d.appendChild(s);
					container.appendChild(d);
				}
				return;
			}

			for (var i = 0; i < digitEls.length; i++) {
				swap(digitEls[i], str[i]);
			}
		}

		function swap(digitEl, char) {
			var current = digitEl.querySelector('span:not(.fu-countdown__out)');
			if (current && current.textContent === char) return;

			if (current) {
				current.classList.add('fu-countdown__out');
				current.addEventListener('animationend', function () {
					current.remove();
				}, { once: true });
			}

			var next = document.createElement('span');
			next.textContent = char;
			next.classList.add('fu-countdown__in');
			next.addEventListener('animationend', function () {
				next.classList.remove('fu-countdown__in');
			}, { once: true });
			digitEl.appendChild(next);
		}

		update();
		setInterval(update, 1000);
	});
});
